/**
 * brandLogos.js — brand logo registry for mockups.
 *
 * Logos are seeded once into Storage at:  content-media/logos/<slug>-<variant>.webp
 * (see scripts/seed-logos — the source PNGs live in the "Black & White Logos" folder).
 *
 * `LOGOS` is the master list (slug + available colour variants). `CLIENT_LOGO_MAP`
 * auto-selects a logo for a client by normalized name; the mockup UI lets the
 * user override the logo and switch the colour variant.
 */

import { mediaUrl } from './media';

export const LOGOS = [
  { slug: 'rashid-fabrics',       label: 'Rashid Fabrics',       variants: ['black', 'white'] },
  { slug: 'amina-khalid',         label: 'Amina Khalid',         variants: ['black', 'white'] },
  { slug: 'dhaanak',              label: 'Dhaanak',              variants: ['black', 'white'] },
  { slug: 'fabrizia',             label: 'Fabrizia',             variants: ['black', 'white', 'green'] },
  { slug: 'haaf',                 label: 'HAAF',                 variants: ['black', 'white', 'blue'] },
  { slug: 'isov',                 label: 'ISov',                 variants: ['black', 'white'] },
  { slug: 'lym',                  label: 'LYM',                  variants: ['black', 'white'] },
  { slug: 'my-sewing-mall',       label: 'My Sewing Mall',       variants: ['black', 'white'] },
  { slug: 'nael',                 label: 'Nael',                 variants: ['black', 'white'] },
  { slug: 'padel-edge',           label: 'Padel Edge',           variants: ['black', 'white', 'green'] },
  { slug: 'signature-aesthetics', label: 'Signature Aesthetics', variants: ['black', 'white'] },
  { slug: 'signature-by-eram',    label: 'Signature by Eram',    variants: ['black', 'white'] },
  { slug: 'tahani-studio',        label: 'Tahani Studio',        variants: ['black', 'white'] },
  { slug: 'vertex',               label: 'Vertex',               variants: ['black', 'white'] },
  { slug: 'wigglybutt',           label: 'Wigglybutt',           variants: ['black', 'white'] },
  { slug: 'strategists',          label: 'Strategists',          variants: ['black', 'white'] },
];

const norm = (s) => (s || '').toLowerCase().replace(/[^a-z0-9]/g, '');

// Client display name (normalized) → logo slug.
const CLIENT_LOGO_MAP = {
  [norm('Rashid Fabrics')]: 'rashid-fabrics',
  [norm('Amina Khalid')]: 'amina-khalid',
  [norm('Dhaanak by Mahnoor')]: 'dhaanak',
  [norm('Dhaanak')]: 'dhaanak',
  [norm('Fabrizia')]: 'fabrizia',
  [norm('HAAF Group')]: 'haaf',
  [norm('HAAF')]: 'haaf',
  [norm('ISov')]: 'isov',
  [norm('LYM Real Estate')]: 'lym',
  [norm('My Sewing Mall')]: 'my-sewing-mall',
  [norm('Nael')]: 'nael',
  [norm('Padel Edge')]: 'padel-edge',
  [norm('Padel Up')]: 'padel-edge',
  [norm('Signature Aesthetics & Wellness')]: 'signature-aesthetics',
  [norm('Signature by Eram')]: 'signature-by-eram',
  [norm('Tahani Studio')]: 'tahani-studio',
  [norm('Vertex Chemicals')]: 'vertex',
  [norm('Vertex')]: 'vertex',
  [norm('Wigglybutt')]: 'wigglybutt',
  [norm('Strategists')]: 'strategists',
};

export function logoUrl(slug, variant = 'black') {
  if (!slug) return '';
  return mediaUrl(`logos/${slug}-${variant}.webp`);
}

export function logoForClientName(name) {
  return CLIENT_LOGO_MAP[norm(name)] || null;
}

export function logoMeta(slug) {
  return LOGOS.find(l => l.slug === slug) || null;
}
